import { FlexBox } from '@airship-platform/jam-web/components';
import Typography from '@mui/material/Typography';
import { PropsWithChildren } from 'react';

interface SOWCardProps {
  sow: {
    title: string;
    shortDescription: string;
  };
}

const SOWCard: React.FC<PropsWithChildren<SOWCardProps>> = ({
  sow,
  children,
}) => (
  <FlexBox
    flexDirection={'row'}
    alignItems={'center'}
    justifyContent={'space-between'}
    gap={2}
  >
    <FlexBox flexDirection={'column'}>
      <Typography variant="h4">{sow.title}</Typography>
      <Typography variant="body2">{sow.shortDescription}</Typography>
    </FlexBox>
    {children}
  </FlexBox>
);

export default SOWCard;
